/**
 * Number of `.vt-dN` delay classes defined in global.css. Items past the cap
 * share the last delay rather than pushing the transition's end further out —
 * the whole document is non-interactive to captured elements until it ends.
 */
export const VT_STAGGER_STEPS = 8;

/**
 * `view-transition-class` accepts a list of idents, and React passes the
 * `enter` prop through verbatim, so the enter class and a delay class ride in
 * the same string. `ordinal` is the item's position among the items entering
 * in the visible window (render order == visual order), not its list index.
 */
export function staggeredEnterClass(base: string, ordinal: number): string {
  const step = Math.min(Math.max(ordinal, 0), VT_STAGGER_STEPS - 1);
  return `${base} vt-d${step}`;
}
